module.exports = __webpack_public_path__ + "static/media/trash-red-large.050c839a.png";